import {DownloaderContract} from 'common/tool/DownloaderContract';
import * as path from 'path';
import * as fs from 'fs';
import * as crypto from 'crypto';
import axios from 'axios';
import {FileSystemContract} from 'common/tool/FileSystemContract';
import {FileSystem} from 'common/tool/FileSystem';

export class Downloader implements DownloaderContract {
    private readonly fileSystem: FileSystemContract;

    public constructor() {
        this.fileSystem = new FileSystem();
    }

    public async image(url: string, outputPath: string, outputName?: string): Promise<string> {
        if (outputName === undefined) {
            outputName = crypto.randomBytes(20).toString('hex') + path.extname(url);
        }
        await this.fileSystem.write(outputPath + path.sep + outputName, '');

        const output: string = path.resolve(outputPath + path.sep + outputName);
        const writer: any = fs.createWriteStream(output);

        const response: any = await axios({
            url,
            method: 'GET',
            responseType: 'stream'
        });

        response.data.pipe(writer);

        return new Promise((resolve, reject) => {
            writer.on('finish', () => resolve(output));
            writer.on('error', reject);
        });
    }
}
